<div class="connect-popup" *ngIf="!_as?.isOnMobilePlatform">
    <p-dialog header="Header" [(visible)]="_connect.displayConnect" [style]="{width: '820px'}" [draggable]="false"
        [modal]="true" [closeOnEscape]="false" [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'" [showHeader]="false">
        <ng-template pTemplate="content">
            <div class="info-request-title">
                <i class="fa fa-info mr-2" aria-hidden="true"></i>
                Request for Information
            </div>
            <div class="close-popup" (click)="onClosePopup()">
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt="close"
                  loading="lazy" ngOptimizedImage>
            </div>
            <div class="info-request">
                <div class="info-request-left d-flex">
                    <div class="info-request-logo">
                        <img ngOptimizedImage [src]="_connect.connect_item_image_url"
                            width="100%" height="100%" [alt]="_connect.connect_item_name" loading="lazy">
                    </div>
                    <div class="info-request-text">
                        <div class="touch-with">Get directly in touch with</div>
                        <h4>{{_connect.connect_item_name}}</h4>
                    </div>
                </div>
                <div class="info-request-right">

                </div>
            </div>
            <div class="connect-form" style="min-height: 550px;">
                <form [formGroup]="_connect.connectForm">
                    <div class="row">
                        <div class="col-7">
                            <div>
                                <label class="mb-2 lb-text" for="request">Send a message</label>
                                <textarea id="request" rows="3" class="form-control" formControlName="message"></textarea>
                                <div class="text-danger" *ngIf="submitted && f['message'].errors">
                                    <div *ngIf="f['message'].errors?.['required']">Please enter your message</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4 offset-1">
                            <div>
                                <label class="mb-2 lb-text" for="request">Request</label>
                                <div *ngFor="let request of requestsFor" class="form-check">
                                    <input class="form-check-input" type="checkbox" [value]="request"
                                        id="{{request}}" (change)="onChange($event)" [checked]="request === _connect.productPageSubject">
                                    <label class="form-check-label" for="{{request}}">{{request}}</label>
                                </div>
                                <div class="text-danger" *ngIf="submitted && f['subject'].errors">
                                    <div *ngIf="f['subject'].errors?.['required']">Please select your request</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-6">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Fist Name" formControlName="name"  pattern="[A-Za-z\s]+">
                                <label for="floatingInput">First Name *</label>
                                <div class="text-danger" *ngIf="submitted && f['name'].errors">
                                    <div *ngIf="f['name'].errors?.['required']">Please enter your first name</div>
                                    <div *ngIf="f['name'].errors?.['pattern']">Name can only contain letters and spaces</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Last Name" formControlName="last_name">
                                <label for="floatingInput">Last Name *</label>
                                <div class="text-danger" *ngIf="submitted && f['last_name'].errors">
                                    <div *ngIf="f['last_name'].errors?.['required']">Please enter your last name</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-6">
                            <div class="form-floating _isb-g">
                                <input type="email" class="form-control" id="floatingInput"
                                    placeholder="Email" formControlName="email">
                                <label for="floatingInput">Email *</label>
                              
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-floating _isb-g">
                                <input type="tel" class="form-control" id="floatingInput"
                                    placeholder="Mobile" formControlName="mobile" minlength="10" maxlength="10">
                                <label for="floatingInput">Mobile *</label>
                               
                            </div>
                            <div class="text-danger" *ngIf="submitted && f['mobile'].errors">
                                <div *ngIf="f['mobile'].errors?.['required']">Please enter your mobile number</div>
                                <div *ngIf="f['mobile'].errors?.['minlength'] || f['mobile'].errors?.['pattern']">Invalid mobile number. Please try again.</div>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row rc-row">
                        <div class="col-6">
                            <p-autoComplete [suggestions]="cities" field="name"
                             (completeMethod)="search($event)" [forceSelection]="true"
                             placeholder="City *" formControlName="city"></p-autoComplete>
                             <div class="text-danger" *ngIf="submitted && f['city'].errors">
                                <div *ngIf="f['city'].errors?.['required']">Please enter your city</div>
                            </div>
                        </div>
                        <div class="col-6">
                            <p-dropdown [options]="_connect.userTypes" optionLabel="name"
                                [style]="{'width':'100%'}" placeholder="User Type *" formControlName="user_type">
                            </p-dropdown>
                            <div class="text-danger" *ngIf="submitted && f['user_type'].errors">
                                <div *ngIf="f['user_type'].errors?.['required']">Please select your profession</div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-6">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Business name" formControlName="business_name">
                                <label for="floatingInput">Business Name</label>
                            </div>
                        </div>
                        <div class="col-6">
                            <div class="form-floating">
                                <input type="number" class="form-control" id="floatingInput"
                                    placeholder="pincode" formControlName="pincode">
                                <label for="floatingInput">Pincode *</label>
                                <div class="text-danger" *ngIf="submitted && f['pincode'].errors">
                                    <div *ngIf="f['pincode'].errors?.['required']">Please select your pincode</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <p class="text-center" style="font-size: 12px;color: #777; margin-bottom: 1rem !important; padding-top: 1.125rem;">
                                I authorise Afterbricks to send promotional offers and communication.
                                <a routerLink="../terms-and-condition">(Privacy Policy).</a>
                                <!-- <a class="terms-link" href="/terms-and-condition" target="_blank">(Terms of use)</a>. The service is reserved to registered users only.  -->
                            </p>
                            
                            <button style="width:fit-content;margin:auto" title="SEND" class="btn btn-primary send-btn" (click)="onSend(_connect.connectForm.value)">
                                <i class="fa fa-envelope-o mr-2" aria-hidden="true"></i>SEND</button>
                        </div>
                    </div>
                </form>

                <div class="row mt-2">
                    <div class="col-12">
                        <p class="term-check-box">
                            <input type="checkbox" name="" id="term" class="checked">
                            <label for="term">
                                By submitting your request, you agree to allow the sharing of your information
                                 with the companies you are contacting in order to receive a response.Please note that 
                                 this service is available exclusively to registered users. Thank you for your understanding and cooperation.
                                <!-- <a>(Privacy Policy).</a> -->
                            </label>
                        </p>
                       
                    </div>
                </div>
            </div>
        </ng-template>
       
    </p-dialog>
</div>

<div class="connect-popup" *ngIf="_as?.isOnMobilePlatform">
    <p-sidebar header="Header" [(visible)]="_connect.displayConnect" [showCloseIcon]="false" [style]="{width: '100%'}" position="bottom" [draggable]="false" [modal]="true" [closeOnEscape]="false"
    [transitionOptions]="'350ms cubic-bezier(0, 0, 0.2, 1)'">
        <ng-template pTemplate="header">
            <div class="info-request-title">
                <i class="fa fa-info mr-2" aria-hidden="true"></i>
                Request for Information
            </div>
            <div class="close-popup" (click)="onClosePopup()" style="top: 8px !important;right: 8px !important;">
                <img src="https://res.cloudinary.com/afterbricks/image/upload/v1643650270/icons/close_nqzrnn.svg" alt=""
                  loading="lazy">
            </div>
        </ng-template>
        <ng-template pTemplate="content">
            <div class="info-request">
                <div class="info-request-left d-flex">
                    <div class="info-request-logo">
                        <img ngOptimizedImage [src]="_connect.connect_item_image_url"
                            width="100%" height="100%" [alt]="_connect.connect_item_name" loading="lazy">
                    </div>
                    <div class="info-request-text">
                        <div class="touch-with">Get directly in touch with</div>
                        <h4>{{_connect.connect_item_name}}</h4>
                    </div>
                </div>
                <!-- <div class="info-request-right">

                </div> -->
            </div>
            <div class="connect-form">
                <form [formGroup]="_connect.connectForm">
                    <div class="row">
                        <div class="col-12 mb-3">
                            <div class="connect-form-tp">
                                <label class="mb-2 lb-text" for="request">Send a message</label>
                                <textarea id="request" rows="3" class="form-control" formControlName="message"></textarea>
                                <div class="text-danger" *ngIf="submitted && f['message'].errors">
                                    <div *ngIf="f['message'].errors?.['required']">Please enter your message</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="connect-form-tp">
                                <label class="mb-2 lb-text" for="request">Request</label>
                                <div *ngFor="let request of requestsFor" class="form-check">
                                    <input class="form-check-input" type="checkbox" [value]="request"
                                        id="{{request}}" (change)="onChange($event)" [checked]="request === _connect.productPageSubject">
                                    <label class="form-check-label" for="{{request}}">{{request}}</label>
                                </div>
                                <div class="text-danger" *ngIf="submitted && f['subject'].errors">
                                    <div *ngIf="f['subject'].errors?.['required']">Please select your request</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-12 mb-3">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Fist Name" formControlName="name">
                                <label for="floatingInput">First Name *</label>
                                <div class="text-danger" *ngIf="submitted && f['name'].errors">
                                    <div *ngIf="f['name'].errors?.['required']">Please enter your first name</div>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Last Name" formControlName="last_name">
                                <label for="floatingInput">Last Name *</label>
                                <div class="text-danger" *ngIf="submitted && f['last_name'].errors">
                                    <div *ngIf="f['last_name'].errors?.['required']">Please enter your last name</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-12 mb-3">
                            <div class="form-floating _isb-g">
                                <input type="email" class="form-control" id="floatingInput"
                                    placeholder="Email" formControlName="email">
                                <label for="floatingInput">Email *</label>
                                <!-- <button class="btn-sent-otp" *ngIf="!isEmailVerified" [disabled]="f.email.invalid || showEmailOtp" (click)="onSendOtp('email')">Send otp</button>
                                        <span class="_isb-g-verify" *ngIf="isEmailVerified"><img src="../../assets/images/verified.png" alt="verified"></span> -->
                            </div>
                        </div>
                        <div class="col-12 mb-3">
                            <div class="form-floating _isb-g">
                                <input type="tel" class="form-control" id="floatingInput"
                                    placeholder="Mobile" formControlName="mobile" minlength="10" maxlength="10">
                                <label for="floatingInput">Mobile *</label>
                                <!-- <button class="btn-sent-otp" *ngIf="!isMobileVerified" [disabled]="f.mobile.value.length<10 || showMobileOtp" (click)="onSendOtp('mobile')">Send otp</button>
                                    <span class="_isb-g-verify" *ngIf="isMobileVerified"><img src="../../assets/images/verified.png" alt="verified"></span> -->
                            </div>
                            <div class="text-danger" *ngIf="submitted && f['mobile'].errors">
                                <div *ngIf="f['mobile'].errors?.['required']">Please enter your mobile number</div>
                                <div *ngIf="f['mobile'].errors?.['minlength'] || f['mobile'].errors?.['pattern']">Invalid mobile number. Please try again.</div>
                            </div>
                        </div>
                    </div>
                    <!-- <div class="row rc-row" *ngIf="showEmailOtp || showMobileOtp">
                        <div class="col-6" *ngIf="showEmailOtp">
                            <div class="form-floating">
                                <input type="email" class="form-control" id="floatingInput"
                                    placeholder="Email" formControlName="email">
                                <label for="floatingInput">Enter email otp *</label>
                            </div>
                        </div>
                        <div class="col-md-6" *ngIf="showMobileOtp">
                            <div class="form-group">
                                <label for="">* Enter otp sent to your mobile</label>
                                <input #otpval type="number" class="form-control" pInputText placeholder="Mobile Otp" minlength="6" maxlength="6" (keyup)="onVerifyOtp(otpval.value,'mobile');mobileOtpError=''">
                                <div class="error-field" *ngIf="mobileOtpError">
                                    <span>{{mobileOtpError}}</span>
                                </div>
                                <p class="timer" *ngIf="interval">Resend Code (in {{interval}} secs)</p>
                                <span class="resend-otp" *ngIf="!interval">Didn't receive otp? <a (click)="onSendOtp('mobile')">Resend OTP</a></span>
                            </div>
                        </div>
                    </div> -->
                    <div class="row rc-row">
                        <div class="col-12 mb-3">
                            <p-autoComplete [suggestions]="cities" field="name"
                             (completeMethod)="search($event)" [forceSelection]="true"
                             placeholder="City *" formControlName="city"></p-autoComplete>
                             <div class="text-danger" *ngIf="submitted && f['city'].errors">
                                <div *ngIf="f['city'].errors?.['required']">Please enter your city</div>
                            </div>
                        </div>
                        <div class="col-12  mb-3">
                            <p-dropdown [options]="_connect.userTypes" optionLabel="name"
                                [style]="{'width':'100%'}" placeholder="User Type *" formControlName="user_type">
                            </p-dropdown>
                            <div class="text-danger" *ngIf="submitted && f['user_type'].errors">
                                <div *ngIf="f['user_type'].errors?.['required']">Please select your profession</div>
                            </div>
                        </div>
                    </div>
                    <div class="row rc-row">
                        <div class="col-12 mb-3">
                            <div class="form-floating">
                                <input type="text" class="form-control" id="floatingInput"
                                    placeholder="Business name" formControlName="business_name">
                                <label for="floatingInput">Business Name</label>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="form-floating">
                                <input type="number" class="form-control" id="floatingInput"
                                    placeholder="pincode" formControlName="pincode">
                                <label for="floatingInput">Pincode *</label>
                                <div class="text-danger" *ngIf="submitted && f['pincode'].errors">
                                    <div *ngIf="f['pincode'].errors?.['required']">Please select your pincode</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="row mt-3 px-3">
                <div class="col-12">
                    <p style="font-size: 12px;color: #777;">
                        By clicking on SEND, you consent to the communication of your data to the companies for which you raise a request in order to receive a response.
                        <a class="terms-link" href="/terms-and-condition" target="_blank">(Terms of use)</a>. The service is reserved to registered users only. 
                    </p>
                </div>
            </div>
        </ng-template>
        <ng-template pTemplate="footer">
            <div class="d-flex align-items-center justify-content-center">
                <button title="SEND" class="btn btn-primary send-btn" (click)="onSend(_connect.connectForm.value)" style="width: 80% !important;height: 41px;">
                    <i class="fa fa-envelope-o mr-2" aria-hidden="true"></i>SEND</button>
            </div>
        </ng-template>
    </p-sidebar>
</div>